// Text der Knoepfe waechst beim Ueberfahren wie im Styleguide (btn-text-scale).
// Ein Textknoten laesst sich nicht skalieren, deshalb kommt der Text in ein
// <span class="button__text">; Knoepfe mit eigenem <span> bleiben, wie sie sind.
const wrapButtonText = (root: ParentNode = document): void => {
	root.querySelectorAll<HTMLElement>('.button').forEach((button) => {
		button.childNodes.forEach((node) => {
			if (node.nodeType !== Node.TEXT_NODE || !node.textContent?.trim()) {
				return
			}
			const span = document.createElement('span')
			span.className = 'button__text'
			button.replaceChild(span, node)
			span.appendChild(node)
		})
	})
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => wrapButtonText())
} else {
	wrapButtonText()
}
